import React, { useState, useEffect, useRef } from "react"
import Card from "./../../atoms/card/card"
import useMediaQuery from "../../../utils/useMediaQuery"
import {
  matrixGame,
  imgProducts,
  pointsByMatch,
  delayFlip
} from "../../../constants/activity-constants"

import "./grid-card.scss"
export default function GridCard(props) {
  const media = useMediaQuery()
  const { level, points, setPoints } = props
  const [pair, setPair] = useState([])
  const [matrixLevelLayout, setMatrixLevelLayout] = useState([])
  const refTimeout = useRef(null)

  const makeCardsforLevel = __level => {
    if (__level < 1) {
      return []
    }
    let levelCards = []
    levelCards.push({ src: imgProducts[0], indexPair: 0 })
    levelCards.push({ src: imgProducts[0], indexPair: 0 })
    for (let index = 1; index <= __level; index++) {
      levelCards.push({ src: imgProducts[index], indexPair: index })
      levelCards.push({ src: imgProducts[index], indexPair: index })
    }
    return unSortList(levelCards)
  }

  const unSortList = __list => {
    let list = [...__list]
    let unSorted = []
    while (list.length > 0) {
      let randomIndex = parseInt(Math.random() * list.length)
      unSorted.push(list.splice(randomIndex, 1)[0])
    }
    return unSorted
  }

  const makeLevelLayout = (__media, __level) => {
    let list = [] // array de cards a renderizar
    let _cardsForLevel = makeCardsforLevel(__level) // genera el array de pares para cada nivel
    matrixGame[__media ? "mobile" : "desktop"][__level].forEach(
      (row, Xindex) => {
        // rows
        row.forEach((flagLevelLayout, Yindex) => {
          //  columns
          let data = null
          if (flagLevelLayout) {
            let spliceData = _cardsForLevel.splice(0, 1)[0]
            data = {
              flip: false,
              src: spliceData.src,
              indexPair: spliceData.indexPair
            }
          }
          list.push({
            data,
            key: `${media ? "mobile" : "desktop"}${Xindex}-${Yindex}`
          })
        })
      }
    )
    return list
  }

  const handleClickCard = objCard => {
    if (pair.length < 2) {
      // console.log("handleClickCard true", objCard)
      flipByIndexList([objCard.index])
      setPair([...pair, { ...objCard }])
    }
  }

  const flipByIndexList = indexList => {
    console.log("flipList:", indexList)

    setMatrixLevelLayout(
      [...matrixLevelLayout].map((card, index) => {
        if (indexList.includes(index)) {
          console.log("flip:", index)
          let newData = { ...card.data, flip: !card.data.flip }
          return { ...card, data: newData }
        } else {
          return card
        }
      })
    )
  }

  useEffect(() => {
    if (pair.length > 1) {
      // console.log(">1")
      if (pair[0].data.indexPair !== pair[1].data.indexPair) {
        // console.log("! match")
        if (refTimeout.current !== null) {
          clearTimeout(refTimeout.current)
        }
        refTimeout.current = setTimeout(() => {
          // console.log("timeout")
          flipByIndexList(
            pair.map(objPair => {
              return objPair.index
            })
          )
          setPair([])
        }, delayFlip)
      } else {
        // console.log("match")
        setPoints(points + pointsByMatch)
        setPair([])
      }
    }
  }, [pair])

  useEffect(() => {
    setMatrixLevelLayout(makeLevelLayout(media, level))
  }, [media, level])

  return (
    <div className="grid-card-element">
      {matrixLevelLayout.map((card, index) => {
        return (
          <Card
            card={{ ...card, index }}
            key={card.key}
            onClick={handleClickCard}
          />
        )
      })}
    </div>
  )
}
